import { get, httpDelete, post } from "@readai/common/api";
import {
  DomainListResponse,
  DomainSuccessResponse,
  DomainVerificationResponse,
  PostDomainBody,
  WorkspaceDomainView,
} from "@readai/common/types";

// Adds a new domain to the specified workspace.
export const addDomainToWorkspace = async (
  workspaceId: string,
  domain: string,
): Promise<DomainSuccessResponse> => {
  const body: PostDomainBody = { domain };
  return post(`/enterprise/workspaces/${workspaceId}/domains`, body, {
    withCreds: true,
  });
};

// Retrieves all domains associated with the specified workspace.
export const getWorkspaceDomains = async (
  workspaceId: string,
): Promise<WorkspaceDomainView[]> => {
  const response: DomainListResponse = await get(
    `/enterprise/workspaces/${workspaceId}/domains`,
    { withCreds: true },
  );
  return response.domains;
};

// Deletes a domain from the specified workspace.
export const deleteWorkspaceDomain = async (
  workspaceId: string,
  domainId: string,
): Promise<DomainSuccessResponse> => {
  return httpDelete(
    `/enterprise/workspaces/${workspaceId}/domains/${domainId}`,
    {
      withCreds: true,
    },
  );
};

// Verifies a domain associated with the specified workspace.
export const verifyWorkspaceDomain = async (
  workspaceId: string,
  domainId: string,
): Promise<DomainVerificationResponse> => {
  return post(
    `/enterprise/workspaces/${workspaceId}/domains/${domainId}/verify`,
    {},
    { withCreds: true },
  );
};
